import store from "@frameworks/web/redux/store";
import { CLIENT_SET_PASSWORD, CLIENT_SET_PASSWORD_ERROR, CLIENT_SET_PASSWORD_HIDE_ERROR, CLIENT_SET_PASSWORD_START_LOADER, CLIENT_SET_PASSWORD_STOP_LOADER, } from "../interface/IClientSetPassword";
class ClientSetPasswordActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    ClientSetPassword(data) {
        this.dispatch({
            type: CLIENT_SET_PASSWORD,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENT_SET_PASSWORD_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENT_SET_PASSWORD_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENT_SET_PASSWORD_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENT_SET_PASSWORD_STOP_LOADER,
        });
    }
}
export default ClientSetPasswordActions;
